export default __webpack_public_path__ + "static/media/guia-4-4.4928bbac.svg";